import { render, staticRenderFns } from "./CbsReportConfig.vue?vue&type=template&id=d1ff31bc&scoped=true"
import script from "./CbsReportConfig.vue?vue&type=script&lang=js"
export * from "./CbsReportConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ff31bc",
  null
  
)

export default component.exports